import api from "services/api";

const URL = "/department";

class DepartmentService {
  getAll() {
    return api.get(URL);
  }

  getById(id) {
    return api.get(`${URL}/${id}`);
  }

  getByEnterpriseId(enterpriseId) {
    return api.get(`${URL}/enterprise/${enterpriseId}`);
  }

  search(params) {
    return api.get(`${URL}/search`, { params });
  }

  create(data) {
    return api.post(URL, data);
  }

  update(id, data) {
    return api.put(`${URL}/${id}`, data);
  }

  delete(id) {
    return api.delete(`${URL}/${id}`);
  }
}

const departmentService = new DepartmentService();
export default departmentService;
